class AlertsHelper {
    errorAlert(text, title) {
        return {
            title: title,
            text: text,
            icon: 'error',
            timer: 6000,
            allowOutsideClick: false
        };
    }

    errorToastElement() {
        return {
            toast: true,
            position: 'bottom-right',
            iconColor: 'red',
            color: 'red',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true
        }
    }

    informationToastElement() {
        return {
            toast: true,
            position: 'center',
            //iconColor: 'red',
            //color: 'red',
            showConfirmButton: true,
            //timer: 5000,
            //timerProgressBar: true
            width: '600px',
        }
    }

    informationCornerToastElement() {
        return {
            toast: true,
            position: 'bottom-right',
            showConfirmButton: false,
            showCloseButton: true,
        };
    }

    informationSuccessElement() {
        return {
            toast: true,
            //iconColor: 'red',
            //color: 'red',
            showConfirmButton: false,
            //timer: 5000,
            //timerProgressBar: true
            width: '600px',
            position: 'bottom-right',
        }
    }

    errorToastAlert(text, title) {
        return {
            icon: 'error',
            title: title,
            text: text,
            timer: 3000,
        }
    }

    successAlert(text, title) {
        return {
            title: title,
            html: text,
            icon: 'success',
            timer: 3000,
            allowOutsideClick: false,
            timerProgressBar: true
        };
    }

    informationAlert(text, title) {
        return {
            icon: "question",
            title: title,
            html: text,

        };
    }

    informationToastAlert(text, title) {
        return {
            icon: 'info',
            title: title,
            text: text,
        };
    }
}

export default new AlertsHelper();